<script lang="typescript">
    import List from "..//list.svelte";
    import Input from "..//input.svelte";
    import Headline6 from "..//typography/headline6.svelte";
    import Subtitle2 from "../typography/subtitle2.svelte";
    import Caption from "../typography/caption.svelte";
    import { ModalSystem } from "../systems";

    export let title = "Title";
    export let icon: any;

    interface Dictionary {
        title: string;
        description: string;
        icon: string;
    }
    export let dictionary: Dictionary = {
        title: "title",
        description: "description",
        icon: "icon",
    };

    export let dictionaryFunc: (item: any) => Dictionary;

    export let items = [
        { title: "Jackes", description: "Asdasdasd" },
        { title: "Anne", desc: "asdasda" },
        { title: "Junior", desc: "asdasdasd" },
        { title: "Anjo", desc: "asdasdasda" },
    ];

    let iItems = items;

    const onSearchInput = (e: any) => {
        let { value } = e.detail;

        if (value && value != "") iItems = filterList(value);
        else iItems = items;
    };

    const getDictionary = (item: any): Dictionary => {
        if (dictionaryFunc) {
            return dictionaryFunc(item);
        } else
            return {
                title: item[dictionary.title],
                description:
                    dictionary.description && item[dictionary.description],
                icon: dictionary.icon && item[dictionary.icon],
            };
    };

    const filterList = (value: string): Array<any> => {
        return items.filter((item) => {
            return (
                getDictionary(item)
                    .title.toLowerCase()
                    .indexOf(value.toLowerCase()) !== -1
            );
        });
    };

    const onSelect = (selected: any) => {
        ModalSystem.setResult(selected);
        ModalSystem.hide();
    };
</script>

<div class="lookup">
    <div class="content">
        <Headline6 text={title} style="margin-bottom: 16px" />
        <Input
            id="searchLookup"
            name="searchLookup"
            on:input={onSearchInput}
            value=""
            label="Procurar"
            placeholder="digite para procurar..."
        />
    </div>

    <List items={iItems}>
        <div slot="item" let:item let:active class="lookup-item columns">
            {#if icon || item.icon}
                <div class="mr-16" on:click={() => onSelect(item)}>
                    <svelte:component
                        this={item.icon || icon}
                        width={24}
                        height={24}
                    />
                </div>
            {/if}

            <div class="rows row-center " on:click={() => onSelect(item)}>
                <Subtitle2 text={getDictionary(item).title} />
                {#if dictionary.description}
                    <Caption text={getDictionary(item).description} />
                {/if}
            </div>
        </div>
    </List>
</div>

<style>
    .lookup {
        max-height: 600px;
        width: 500px;
        overflow-y: auto;
    }
    .content {
        padding: 16px;
    }
    .rows {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .columns {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
    }
    .mr-16 {
        margin-right: 16px;
    }

    .row-center {
        justify-content: center;
    }

    .lookup-item {
        overflow: hidden;
        justify-content: center;
        align-items: center;
        /* padding: 0 16px; */
        border-bottom: 1px solid var(--color-level-2);
        color: var(--color-level-6);
        padding: 0 16px;
    }
</style>
